import { sqliteTable, text } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";

// ============================================================================
// vehicle_documents — เอกสารรถ
// ============================================================================
export const fleetVehicleDocuments = sqliteTable("fleet_vehicle_documents", {
  id: text("id").primaryKey(), // ULID
  vehicleId: text("vehicle_id").notNull().references(() => fleetVehicles.id),
  documentType: text("document_type", {
    enum: [
      "registration_copy",
      "insurance_policy",
      "act_policy",
      "purchase_receipt",
      "inspection_cert",
      "other",
    ],
  }).notNull(),
  documentName: text("document_name").notNull(),
  fileUrl: text("file_url").notNull(),
  expiryDate: text("expiry_date"),
  notes: text("notes"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type FleetVehicleDocument = typeof fleetVehicleDocuments.$inferSelect;
export type NewFleetVehicleDocument = typeof fleetVehicleDocuments.$inferInsert;
